var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.8,
    height: 66.122,
    viewBox: "0 0 50.8 66.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.683,33.96h-.141V27.568c0-11.114-9.093-20.559-20.183-20.371a19.9,19.9,0,0,0-19.526,19.855v.611a1.675,1.675,0,0,0,1.668,1.668h5.334a1.675,1.675,0,0,0,1.668-1.668v-.188a11.459,11.459,0,0,1,10.456-11.584,11.182,11.182,0,0,1,11.889,11.137v6.908H157.4v.023H142.2a5.242,5.242,0,0,0-5.1,5.216v28.9a5.245,5.245,0,0,0,5.24,5.24h40.32a5.245,5.245,0,0,0,5.24-5.24V39.2A5.21,5.21,0,0,0,182.683,33.96ZM165.625,54.942A1.129,1.129,0,0,0,165.108,56c.023,2.115.023,4.229,0,6.368h0a2.229,2.229,0,0,1-1.2,2.138,2.483,2.483,0,0,1-3.712-2.138V55.976a1.109,1.109,0,0,0-.47-1.01,4.828,4.828,0,0,1-1.6-5.968,4.94,4.94,0,0,1,9.446,1.95A4.474,4.474,0,0,1,165.625,54.942Z",
    transform: "translate(-137.1 -7.194)",
    fill: "#f90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeLockIcon);
export default __webpack_public_path__ + "static/media/orangeLockIcon.daccd1a185c6aaef41974f57542dcda2.svg";
export { ForwardRef as ReactComponent };